import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import utils from '../../utils';
import { PLATFORM } from '../../constants';

var NetEnt = /*#__PURE__*/function (_GameInterface) {
  _inherits(NetEnt, _GameInterface);

  var _super = _createSuper(NetEnt);

  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function NetEnt(args) {
    var _this;

    _classCallCheck(this, NetEnt);

    _this = _super.call(this, args);

    _this.jsonParserEvent = function (payload) {
      var soundEffects = store.getState().playerInfo.soundEffects;

      if (soundEffects !== _this.currentSoundSetting) {
        _this.setSound();
      }

      switch (payload.event || payload.eventName) {
        case 'gameReady':
          _this.setSound();

          _this._gameReady();

          _this.sendAnalyticEvent();

          break;

        case 'gameRoundEnded':
          _this.getEvent('betInCents');

          _this.getEvent('winInCents');

          _this.getEvent('balanceInCents');

          break;

        case 'gameError':
          if (payload['100'] || payload['15'] || payload['10'] || payload.params === 100 || payload.params === 15 || payload.params === 10) {
            _this._outOfCoins();

            _this.showOutOfCoinsScreen();
          }

          break;

        case 'gameProp':
          _this.checkEventData(payload.value, payload.item);

          break;

        default:
          {
            console.log('Unhandled event.', payload);
            break;
          }
      }
    };

    _this.checkEventData = function (incomingData, eventName) {
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
          balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;

      switch (eventName) {
        case 'betInCents':
          _this._currentBet = parseInt(incomingData) / 100;

          _this.AddSpinXP(_this._currentBet);

          store.dispatch(setSpinEvent({
            amount: _this._currentBet,
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WAGE,
            gameId: gameId
          }));
          break;

        case 'winInCents':
          var win = parseInt(incomingData) / 100;
          if (win !== 0 && win >= 10 * _this._currentBet && utils.getPlatform() !== PLATFORM.WEB) _this.showRateUsScreen();

          if (win > 0) {
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WIN,
              gameId: gameId,
              amount: win
            }));

            _this.SetLastWin(win);
          }

          break;

        case 'balanceInCents':
          var currentBalance = parseInt(incomingData) / 100;
          store.dispatch(setSpinEvent({
            balanceBefore: balance ? balance : currentBalance,
            balanceAfter: currentBalance
          }));

          if (currentBalance < _this._currentBet) {
            _this._outOfCoins();

            _this.showOutOfCoinsScreen();
          }

          break;

        default:
          break;
      }
    };

    _this.getEvent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventName) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.sendEvent({
                  eventType: 'GET',
                  event: eventName
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this._currentRound = 0;
    _this._lastWinRound = 0;
    _this._currentBet = 0;
    _this.currentSoundSetting = false;
    return _this;
  }
  /**
   * NetEnt Event Handler
   * @param {import("./helpers/parseEvent").ParsedEvent} event
   */


  _createClass(NetEnt, [{
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent({
        eventType: 'SET',
        event: 'audio',
        value: soundEffects
      });
      this.currentSoundSetting = soundEffects;
    }
  }]);

  return NetEnt;
}(GameInterface);

export default NetEnt;